(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["satin-availability"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('availability-request')) {
    customElements.define('availability-request', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.productForm = this.previousElementSibling;
        this.trigger = this.productForm?.querySelector('.notify-trigger');
        this.dialog = this.querySelector('dialog');
        this.trigger?.addEventListener('click', () => {
          this.dialog.showModal();
          this.querySelector('input[type="email"]')?.focus();
        }, options);
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.trigger?.focus(), options);
        this.sync();
        if (this.querySelector('[data-result]') && location.hash === '#' + this.querySelector('form').id) this.dialog.showModal();
      }
      disconnectedCallback() { this.controller?.abort(); }
      setLoading() {
        if (this.trigger) this.trigger.disabled = true;
        if (this.dialog.open) this.dialog.close();
      }
      syncFrom(html) {
        const source = [...html.querySelectorAll('availability-request')].find(node => node.dataset.section === this.dataset.section);
        if (!source) return;
        for (const key of ['variantId', 'available', 'variantTitle']) this.dataset[key] = source.dataset[key] || '';
        this.sync();
      }
      sync() {
        const soldOut = Boolean(this.dataset.variantId) && this.dataset.available === 'false';
        this.productForm?.toggleAttribute('data-notify-sold-out', soldOut);
        if (this.trigger) this.trigger.disabled = !soldOut;
        const variantId = this.querySelector('[name="contact[variant_id]"]');
        const shade = this.querySelector('[name="contact[shade]"]');
        if (variantId) variantId.value = this.dataset.variantId;
        if (shade) shade.value = this.dataset.variantTitle || this.querySelector('[name="contact[product]"]').value;
        this.querySelector('[data-variant-label]').textContent = this.dataset.variantTitle;
        const returnTo = this.querySelector('[name="return_to"]');
        if (returnTo) {
          const url = new URL(returnTo.value, location.origin);
          url.searchParams.set('variant', this.dataset.variantId);
          returnTo.value = url.pathname + url.search + url.hash;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
